import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { AuthProvider } from "./hooks/context/AuthContext";
import "./locales/i18n"; // i18n.tsを読み込む

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ChakraProvider value={defaultSystem}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ChakraProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
